/* eslint-disable */
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/test",
    component: () => import("../views/TestView.vue"),
  },
  // {
  //   path: "/about",
  //   component: () => import("../views/AboutView.vue"),
  // },
  // {
  //   path: "/detail/:uid",
  //   name: "Detail",
  //   component: () => import("../views/DetailVuew.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
